import styled from "styled-components";

export const SectionHeader = styled.div`
  font-size: 1.7rem;
  font-weight: 600;
  height: 4rem;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1rem;
  .subtitle {
    font-size: 1.4rem;
    font-weight: 400;
  }
`;

export const TableWrapper = styled.div`
  overflow: auto;
`;

export const BackgroundImage = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: -2;
  background-image: url("/static/stars.png");
`;

export const SectionWrapper = styled.section`
  /* width: 35rem;
  height: 45rem; */
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  border: 1px solid white;
  overflow: hidden;
  .title {
    /* height: 3rem; */
    font-size: 1.7rem;
    font-weight: 600;
    margin-top: 1rem;
    flex: 1;
  }
  .subtitle {
    font-size: 1.45rem;
  }
  .content {
    width: 100%;
    height: 42rem;
    display: flex;
    flex-direction: column;
    overflow: hidden auto;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: bottom;
    }
    .tab-wrapper {
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin-top: 8px;
    }
  }
`;
